module.exports = __webpack_public_path__ + "img/choose_country.032ed6e7.webp";